import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProceduresService} from '../_services/procedures.service';
import {Procedure} from '../_models/procedure.model';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../../_upsell/shared/services/user.service';
import {Subscription} from 'rxjs';
import {CurrentUserDataService} from '../../../shared/_services/current-user-data.service';

@Component({
    selector: 'app-view-procedure',
    templateUrl: './view-procedure.component.html',
    styleUrls: ['./view-procedure.component.scss']
})
export class ViewProcedureComponent implements OnInit, OnDestroy {

    // User Roles
    userRoles = [];

    // Procedure Data
    procedureData: Procedure;
    procedureId: string;
    procedureLoaded: boolean;
    procedureAuthor: string;
    routeSubscribe: any;

    // User Consent
    userConsent: false;
    checkUserConsent: boolean;
    userList: any = [];


    // Feedback Messages
    formSent: boolean;
    formResponse: boolean;
    errorMsg: string;
    successMsg: string;

    // Subscriptions
    subscriptions: Subscription[] = [];

    constructor(private proceduresService: ProceduresService,
                private route: ActivatedRoute,
                private router: Router,
                private userService: UserService,
                public currentUserData: CurrentUserDataService) {
    }

    ngOnInit(): void {
        this.getUser();
        this.routeSubscribe = this.route.params.subscribe(params => {
            this.procedureId = params.id;
            if (this.procedureId) {
                this.getProcedureById(this.procedureId);
                this.checkIfUserGaveConsent(this.procedureId);
                this.getSolicitedUsers(this.procedureId);
            } else {
                this.router.navigate(['/procedures/list'], {relativeTo: this.route}).then(() => {
                });
            }
        });
    }

    getAuthor(id) {
        const getUserById = this.userService.getUserById(id).subscribe((data: any) => {
            this.procedureAuthor = data.firstName + ' ' + data.lastName;
        });
        this.subscriptions.push(getUserById);
    }

    // Get User Data
    getUser() {
        const getCurrentUser = this.currentUserData.getCurrentUserData().subscribe(data => {
            this.userRoles = data.roles;
        });

        // Add request to unsubscribe list
        this.subscriptions.push(getCurrentUser);

    }

    getProcedureById(id) {
        const getProcedureById = this.proceduresService.getProcedureById(id).subscribe((data: any) => {
            this.procedureData = data;
            this.procedureLoaded = true;
            this.getAuthor(data.mainId);
        });
        this.subscriptions.push(getProcedureById);
    }

    getSolicitedUsers(id) {
        this.proceduresService.teamMembersNotInProcedureConsent(id).subscribe((data: any) => {
            this.userList = data;
            
        });
    }

    checkIfUserGaveConsent(id) {
        const isUserInConsentList = this.proceduresService.isUserInConsentList(id).subscribe((data: any) => {
            this.checkUserConsent = data.success;
        });
        this.subscriptions.push(isUserInConsentList);
    }

    addUserToConsent() {
        const addProcedureConsent = this.proceduresService.addProcedureConsent(this.procedureId, this.userConsent).subscribe(() => {
            this.checkIfUserGaveConsent(this.procedureId);
            this.getSolicitedUsers(this.procedureId);

            // Feedback Message
            this.feedbackMsg('success', 'You successfully gave your consent!');
        });
        this.subscriptions.push(addProcedureConsent);
    }


    // FeedBack Msg
    feedbackMsg(type, message) {

        if (type === 'success') {
            this.formSent = true;
            this.formResponse = true;
            this.successMsg = message;

            setTimeout(() => {
                this.formSent = false;
            }, 4000);

        } else if (type === 'error') {
            this.formSent = true;
            this.formResponse = false;
            this.errorMsg = message;

            setTimeout(() => {
                this.formSent = false;
            }, 4000);
        }
    }

    // Resize & Display
    toDisplay(value) {
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        return width <= value;

    }

    ngOnDestroy() {
        this.subscriptions.forEach(sb => sb.unsubscribe());
    }

}
